import { render, staticRenderFns } from "./FreeModeBook.vue?vue&type=template&id=04e9ac1b&scoped=true&"
import script from "@/scripts/FreeMode/FreeModeBook/index.js?vue&type=script&lang=js&"
export * from "@/scripts/FreeMode/FreeModeBook/index.js?vue&type=script&lang=js&"
import style0 from "./FreeModeBook.vue?vue&type=style&index=0&id=04e9ac1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e9ac1b",
  null
  
)

export default component.exports